import { render, staticRenderFns } from "./PropiedadItem.vue?vue&type=template&id=b98d7ac0&"
import script from "./PropiedadItem.vue?vue&type=script&lang=js&"
export * from "./PropiedadItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports